import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_ListLaunchesCommand, se_ListLaunchesCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class ListLaunchesCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Evidently", "ListLaunches", {})
    .n("EvidentlyClient", "ListLaunchesCommand")
    .f(void 0, void 0)
    .ser(se_ListLaunchesCommand)
    .de(de_ListLaunchesCommand)
    .build() {
}
